import React, {useContext, useEffect, useState} from 'react'
import {useParams} from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import {UserContext} from "./UserContext";
import ReactModal from "react-modal";
import AllTripsMap from "./AllTripsMap";
import axios from "axios";
import {getBearerToken, getServerUrl, showTrips} from "./utils/utils";
import Image from "./Image";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import AddIcon from '@mui/icons-material/Add';
import RankingListModal from "./RankingListModal";
import EditUserModal from "../EditUserModal";
import ViewTrip from "./ViewTrip";
import TripModal from "./TripModal";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import BucketListModal from "./categories/BucketListModal";

function Profile() {
    const [selectedTripRankingList, setSelectedTripRankingList] = React.useState(null);
    const [selectedTripCategoryButton, setSelectedTripCategoryButton] = React.useState();
    const [selectedImageRankingList, setSelectedImageRankingList] = React.useState(null);
    const [selectedImageCategoryButton, setSelectedImageCategoryButton] = React.useState();
    const {user, allTrips} = useContext(UserContext)
    const [trips, setTrips] = useState([])
    const [locations, setLocations] = useState([])
    const [retrievingTrips, setRetrievingTrips] = useState(false)
    const [locationsClickedStatus, setLocationsClickedStatus] = useState({})
    const [tripImages, setTripImages] = useState([])
    const [tripRankingLists, setTripRankingLists] = useState([])
    const [tripRankingList, setTripRankingList] = useState(null)
    const [imageRankingLists, setImageRankingLists] = useState([])
    const [imageRankingImageList, setImageRankingImageList] = useState([])
    const [openRankingListModal, setOpenRankingListModal] = useState(false)
    const [selectedRankingListType, setSelectedRankingListType] = useState(null)
    const [selectedRankingListId, setSelectedRankingListId] = useState(null)
    const [hoveredRankingListId, setHoveredRankingListId] = useState(null)
    const [hoveredRankingListType, setHoveredRankingListType] = useState(null)
    const [openUserModal, setOpenUserModal] = useState(false)
    const [profileUser, setProfileUser] = useState(null)
    const [openViewTripModal, setOpenViewTripModal] = useState(false)
    const [viewTripId, setViewTripId] = useState(null)
    const [selectedMarkerLocation, setSelectedMarkerLocation] = useState(null)
    const [selectedBucketList, setSelectedBucketList] = useState('')
    const {id} = useParams()
    const userOwnsPage = Number(user?.id) === Number(id)

    useEffect(() => {
        retrieveTrips()
        retrieveTripRankingLists()
        retrieveImageRankingLists()
        if (id !== user.id) {
            getUser()
        } else {
            setProfileUser(user)
        }

    }, [id])

    // useEffect(() => {
    //     if (allTrips?.length > 0) {
    //         setLocations(allTrips.map(trip => trip.location))
    //     }
    // }, [allTrips])

    useEffect(() => {
        if (!tripImages.length > 0 && trips.length > 0 && selectedImageCategoryButton === 'recent') {
            retrieveTripImages(trips[0].id)
        } else if (selectedImageCategoryButton === 'favorite') {
            if (trips.length > 0 && selectedImageRankingList !== 'create-image-list' && selectedImageRankingList !== 'create-trip-list' && selectedImageRankingList) {
                retrieveSelectedRankingList(selectedImageRankingList, true)
            }
        }

    }, [tripImages, selectedImageCategoryButton, trips, selectedImageRankingList])

    useEffect(() => {
        if (selectedTripRankingList) {
            retrieveSelectedRankingList(selectedTripRankingList, false)
        }
    }, [selectedTripRankingList])

    const retrieveTripImages = async (tripId) => {
        axios.get(`${getServerUrl()}/trip/${tripId}/images?loadCoverImage=true&shortenVideo=true&loadAsBatch=true&batchLoadIndex=0`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                if (response.data.length <= 5) {
                    if (tripImages.length !== 0 || response.data.length !== 0) {
                        setTripImages(response.data);
                    }
                } else {
                    retrieveImage(response.data, 0, response.data.length)
                }
            })
    }

    function getUser() {
        axios.get(`${getServerUrl()}/user/${id}`)
            .then(response => {
                setProfileUser(response.data)
            })
    }

    const retrieveTrips = async () => {
        axios.get(`${getServerUrl()}/user/${id}/trip/page/0`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setTrips(response.data.trips);
                setLocations(response.data.locations)
                setLocationsClickedStatus(obj => {
                    const updatedObj = {...obj}
                    response.data.locations.forEach(location => {
                        updatedObj[location] = false
                    })
                    return updatedObj
                })
                setRetrievingTrips(false)

            })
    }

    const retrieveTripRankingLists = async () => {
        axios.get(`${getServerUrl()}/user/${id}/trip/rankingList`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setTripRankingLists(response.data)
                if (response.data.length > 0) {
                    setSelectedTripCategoryButton('favorite')
                    setSelectedTripRankingList(response.data[0].id)
                    setTripRankingList(response.data[0])
                    // setImageRankingImageList(response.data[0].rankingObjects.map(rankingObject => rankingObject.image))
                } else {
                    setSelectedTripCategoryButton('recent')
                }
            })
    }

    const retrieveImageRankingLists = async () => {
        axios.get(`${getServerUrl()}/user/${id}/image/rankingList`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                if (response.data.length > 0) {
                    setSelectedImageCategoryButton('favorite')
                    setSelectedImageRankingList(response.data[0].id)
                    setImageRankingLists(response.data)
                } else {
                    setSelectedImageCategoryButton('recent')
                }
            })
    }

    const retrieveSelectedRankingList = async (id, isImageList) => {
        axios.get(`${getServerUrl()}/rankingList/${id}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                if (isImageList) {
                    setImageRankingImageList(response.data.rankingObjects.map(rankingObject => rankingObject.image))
                } else {
                    setTripRankingList(response.data)
                }
            })
    }

    const retrieveImage = async (imageList, index, indexToStopOn) => {
        if (index < indexToStopOn && index < imageList.length) {
            axios.get(`${getServerUrl()}/image/${imageList[index].id}?loadCoverImage=true&shortenVideo=true`, {
                headers: {Authorization: `Bearer ${await getBearerToken()}`}
            })
                .then(response => {
                    imageList[index].image_location = response.data.image_location
                    imageList[index].videoCoverImage = response.data.videoCoverImage
                    imageList[index].video_location = response.data.video_location
                    imageList[index].fileType = response.data.fileType
                    setTripImages([...imageList])
                    retrieveImage(imageList, index + 1, indexToStopOn)
                })
        }
    }

    const displayImages = (imageList, isRankingList) => {
        return imageList?.filter(image => {
            return image?.image_location || image?.video_location
        }).map((image, index) => {
            return (
                <div className="image-ranking-list-image-container">
                    {isRankingList && (
                        <div className="trip-list-number">
                            <div>{index + 1}</div>
                        </div>
                    )}
                    <Image
                        imageFile={image}
                        onClick={() => {
                        }}
                        imageIdsForNewActivity={[]}
                        key={image.id}
                        showVideoCoverImage={true}
                    />
                </div>
            )
        })
    }

    const showRankingListButtons = (rankingLists, selectedRankingList, setSelectedRankingList, isTripRankingList) => {
        console.log(tripRankingLists)
        const rankingListButtons = rankingLists.map((rankingList, index) => {
            const buttonStyle = {}
            if (hoveredRankingListId !== rankingList.id) {
                buttonStyle.display = "none"
            } else {
                buttonStyle.bottom = -25
            }

            return (
                <ToggleButton
                    value={rankingList.id}
                    aria-label="left aligned"
                    onMouseEnter={() => {
                        if (userOwnsPage) {
                            setHoveredRankingListId(rankingList.id)
                        }
                    }}
                    onMouseLeave={() => {
                        if (userOwnsPage) {
                            setHoveredRankingListId(null)
                        }
                    }}
                >
                    <div
                        className="ranking-list-tile"

                    >
                        {rankingList.name}
                        {userOwnsPage && (
                            <button
                                className="edit-ranking-list-button"
                                onClick={() => {
                                    setOpenRankingListModal(true)
                                    setSelectedRankingListId(rankingList.id)
                                    setSelectedRankingListType(isTripRankingList ? 'trip' : 'image')
                                }}
                                style={buttonStyle}
                            >
                                Edit
                            </button>
                        )}
                    </div>
                </ToggleButton>
            )
        })
        if (userOwnsPage) {
            rankingListButtons.push(
                <ToggleButton
                    onClick={() => {
                        setOpenRankingListModal(true)
                        console.log("opening ranking list modal")
                        setSelectedRankingListType(isTripRankingList ? 'trip' : 'image')
                    }}
                    value={isTripRankingList ? 'create-trip-list' : 'create-image-list'}>
                    <AddIcon/>
                </ToggleButton>)
        }
        return (
            <ToggleButtonGroup
                fullWidth={true}
                size="small"
                value={selectedRankingList}
                exclusive
                onChange={(event, selected) => {
                    if (selected !== "create-trip-list") {
                        setSelectedRankingList(selected)
                    }
                }}
                aria-label="text alignment"
            >
                {rankingListButtons}
            </ToggleButtonGroup>
        );
    }

    const showTripCategoryButtons = (categoryButton, setCategoryButton, isRankingTrips) => (
        <>
            <div className="profile-button-group-container">
                <ToggleButtonGroup
                    size="small"
                    fullWidth={true}
                    value={categoryButton}
                    exclusive
                    onChange={(event, selected) => {
                        if (selected) {
                            setCategoryButton(selected)
                        }
                    }}
                    aria-label="text alignment"
                >
                    <ToggleButton value='favorite' aria-label="left aligned">
                        Favorite {isRankingTrips ? "Trips" : "Photos"}
                    </ToggleButton>
                    <ToggleButton value='recent' aria-label="left aligned">
                        Recent {isRankingTrips ? "Trips" : "Photos"}
                    </ToggleButton>
                </ToggleButtonGroup>
            </div>
            {selectedTripCategoryButton === 'favorite' && (
                <div
                    className="profile-trip-ranking-buttons"
                    onMouseEnter={() => {
                        if (userOwnsPage) {
                            setHoveredRankingListType('trip')
                        }
                    }}
                    onMouseLeave={() => {
                        if (userOwnsPage) {
                            setHoveredRankingListType(null)
                        }
                    }}
                    style={{paddingBottom: 15}}
                >
                    {showRankingListButtons(tripRankingLists, selectedTripRankingList,
                        setSelectedTripRankingList, true)}
                </div>
            )}
        </>
    )

    const tripRankingListWithTripsRanked = {
        trips: tripRankingList?.rankingObjects?.map((rankingObject, index) => {
            const trip = rankingObject.trip
            trip.listNumber = index + 1
            return trip
        }),
        id: tripRankingList?.id
    }

    const imageRankingListsWithImagesRanked = imageRankingLists?.map(imageRankingList => {
        return {
            images: imageRankingList?.rankingObjects.map((rankingObject, index) => {
                const image = rankingObject.image
                image.listNumber = index + 1
                return image
            }),
            id: imageRankingList.id
        }
    })

    const onTripSelect = trip => {
        setViewTripId(trip.id)
        setOpenViewTripModal(true)
    }

    // const selectedTripRankingListObject = tripRankingListsWithTripsRanked?.find(tripRankingList => tripRankingList.id === selectedTripRankingList) || []

    const renderProfileTripList = () =>
        <div className="profile-trip-list">
            {selectedImageCategoryButton !== 'create-trip-list' && (<div className="profile-trips-div">
                {showTrips(selectedTripCategoryButton === 'favorite' ? tripRankingListWithTripsRanked?.trips : trips, onTripSelect)}
            </div>)}
        </div>


    return (
        <div id="user-profile-page">
            <BucketListModal selectedBucketList={selectedBucketList} onClose={() => setSelectedBucketList('')}/>
            <EditUserModal isOpen={openUserModal} onClose={() => setOpenUserModal(false)}/>
            <RankingListModal
                isOpen={openRankingListModal}
                rankingListType={selectedRankingListType}
                isNew={true}
                rankingListId={selectedRankingListId}
                onClose={(rankingList, rankingListId, shouldDelete) => {
                    setOpenRankingListModal(false)
                    setSelectedRankingListId(null)
                    if (selectedRankingListType === 'image') {
                        if (shouldDelete) {
                            const filteredImageRankingLists = imageRankingLists.filter(imageRankingList => imageRankingList.id !== rankingListId)
                            setSelectedImageRankingList(filteredImageRankingLists[0]?.id)
                            setImageRankingLists(filteredImageRankingLists)
                        } else {
                            const existingRankingList = imageRankingLists.find(imageRankingList => imageRankingList.id === rankingList?.id)
                            if (rankingList && !existingRankingList) {
                                setImageRankingLists([rankingList, ...imageRankingLists])
                            } else if (rankingList && existingRankingList) {
                                setImageRankingLists([rankingList, ...imageRankingLists.filter(list => list.id !== rankingList.id)])
                            }
                            setSelectedImageRankingList(rankingList ? rankingList.id : imageRankingLists?.[0]?.id)
                        }
                    } else {
                        if (shouldDelete) {
                            const filteredTripRankingLists = tripRankingLists.filter(tripRankingList => tripRankingList.id !== rankingListId)
                            setSelectedTripRankingList(filteredTripRankingLists[0]?.id)
                            setTripRankingLists(filteredTripRankingLists)
                        } else {
                            const existingRankingList = tripRankingLists.find(tripRankingList => tripRankingList.id === rankingList?.id)
                            if (rankingList && !existingRankingList) {
                                setTripRankingLists([rankingList, ...tripRankingLists])
                            } else if (rankingList && existingRankingList) {
                                setTripRankingLists([rankingList, ...tripRankingLists.filter(list => list.id !== rankingList.id)])
                            }
                            setSelectedTripRankingList(rankingList ? rankingList.id : tripRankingLists?.[0]?.id)
                        }
                    }
                }}
            />
            <ViewTrip
                open={openViewTripModal}
                selectedTripId={viewTripId}
                onClose={(updatedTrip, deleteTripBoolean) => {
                    setOpenViewTripModal(false)
                    setViewTripId(null)
                    if (updatedTrip && deleteTripBoolean) {
                        let numDeletedTripLocation = 0
                        trips.forEach(trip => {
                            if (updatedTrip.location === trip.location) {
                                numDeletedTripLocation++
                            }
                        })
                        if (numDeletedTripLocation === 1) {
                            setLocations(locations.filter(location => location !== updatedTrip.location))
                        }
                        setTrips(trips.filter(trip => trip.id !== updatedTrip.id))
                    } else if (updatedTrip && !deleteTripBoolean) {
                        const updatedTrips = trips.map(trip => {
                            const tripCopy = {...trip}
                            if (trip.id === updatedTrip.id) {
                                tripCopy.trip_profile_image = updatedTrip.profilePicture
                                tripCopy.profileImageId = updatedTrip.profilePictureId
                            }
                            return tripCopy
                        })
                        setTrips(updatedTrips)
                    }
                }}
                onTripUpdate={updatedTrip => {
                    setOpenViewTripModal(false)
                    setViewTripId(null)
                    setTrips(trips.map(trip => {
                        if (trip.id === updatedTrip.id) {
                            return updatedTrip
                        }
                        return trip
                    }))
                }}
            />
            <div className="profile-container">
                {/*{window.innerWidth > 600 && renderProfileTripList()}*/}
                <div id="profile">
                    <div className="user-avatar">
                        <Avatar sx={window.innerWidth > 600 ? {width: 150, height: 150} : {width: 50, height: 50}}
                                src={userOwnsPage ? user?.profilePictureUrl : profileUser?.profilePictureUrl}/>
                        <h4>{userOwnsPage ? user?.displayName : profileUser?.username}</h4>
                        {userOwnsPage && (
                            <button onClick={() => setOpenUserModal(true)} className="edit-profile">Edit</button>
                        )}
                        {window.innerWidth >= 500 && (
                            <FormControl fullWidth className="select-bucket-list-dropdown">
                                <InputLabel id="demo-simple-select-label">Bucket Lists</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedBucketList}
                                    label="Bucket Lists"
                                    onChange={e => setSelectedBucketList(e.target.value)}
                                >
                                    <MenuItem value={"United States"}>United States</MenuItem>
                                    <MenuItem value={"Europe"}>Europe</MenuItem>
                                    <MenuItem value={"World"}>World</MenuItem>
                                    <MenuItem value={"National Park"}>National Parks</MenuItem>
                                    <MenuItem value={"NFL"}>NFL</MenuItem>
                                    <MenuItem value={"MLB"}>MLB</MenuItem>
                                </Select>
                            </FormControl>
                        )}
                    </div>
                    <AllTripsMap
                        initialZoomLevel={1.5}
                        locations={locations ? locations : []}
                        onMarkerEvent={tripLocation => {
                            setSelectedMarkerLocation(tripLocation)
                        }}
                        locationsClickedStatus={locationsClickedStatus}
                        includeZoom={true}
                        onTripsPage={true}
                        retrievingLocations={retrievingTrips}
                        viewingMultipleTrips={true}
                        fullscreen={false}
                        trips={trips}
                        zoomInOnTrips={true}
                        rankingTrips={selectedTripCategoryButton === 'favorite' ? tripRankingListWithTripsRanked?.trips : []}
                    />
                    <TripModal location={selectedMarkerLocation} fullscreen={true}
                               endpoint={`/user/${id}/trip/location/`}/>
                    <div style={{width: '100vw'}}>
                        {showTripCategoryButtons(selectedTripCategoryButton, setSelectedTripCategoryButton, true)}
                    </div>
                    {window.innerWidth >= 600 && renderProfileTripList()}
                    {/*{window.innerWidth >= 600 && (*/}
                    {/*    <div className="profile-image-container">*/}
                    {/*        <div className='trip-photos-buttons'>*/}
                    {/*            {showTripCategoryButtons(selectedImageCategoryButton, setSelectedImageCategoryButton, false)}*/}
                    {/*            {selectedImageCategoryButton === 'favorite' && (*/}
                    {/*                <div className="profile-button-group-container">*/}
                    {/*                    {showRankingListButtons(imageRankingLists, selectedImageRankingList,*/}
                    {/*                        setSelectedImageRankingList)}*/}
                    {/*                </div>*/}
                    {/*            )}*/}
                    {/*        </div>*/}
                    {/*        {selectedImageCategoryButton !== 'create-image-list' && (*/}
                    {/*            <div id="view-trip-images">*/}
                    {/*                {selectedImageCategoryButton === 'recent' ? displayImages(tripImages, false) : displayImages(imageRankingImageList, true)}*/}
                    {/*            </div>*/}
                    {/*        )}*/}
                    {/*    </div>*/}
                    {/*)}*/}
                </div>
            </div>
        </div>

    )
}

export default Profile;